module.exports = __webpack_public_path__ + "img/signupLogoDS.1ba20d4a.svg";